// extracted by mini-css-extract-plugin
export var btn = "Closing-module--btn--dc019";
export var btnOutlinePrimary = "Closing-module--btn-outline-primary--cc88b";
export var btnPrimary = "Closing-module--btn-primary--06565";
export var formSelect = "Closing-module--form-select--63135";
export var inner = "Closing-module--inner--fcc91";
export var lead = "Closing-module--lead--6112c";
export var note = "Closing-module--note--869fa";
export var section = "Closing-module--section--ce48e";
export var support = "Closing-module--support--bb22c";
export var text = "Closing-module--text--e6286";
export var title = "Closing-module--title--29fba";